const SET_NAME = 'scratch-gui/connection-modal/setName';
const CLEAR_NAME = 'scratch-gui/connection-modal/clearName';
const SET_REALTIME_PROTOCAL_CONNECTION = 'scratch-gui/connection-modal/setRealtimeConnection';
const SET_LIST_ALL = 'scratch-gui/connection-modal/setListAll';
const SET_USB_STATUS = 'scratch-gui/connection-modal/setUsbStatus';
const SET_USB_CHECKING = 'scratch-gui/connection-modal/setUsbChecking';
const CLEAR_USB_STATUS = 'scratch-gui/connection-modal/clearUsbStatus';

const initialState = {
    peripheralName: null,
    realtimeConnection: false,
    isListAll: false,
    /** Status USB (Web Serial): null = não verificado, number = quantidade de portas já concedidas */
    usbPortCount: null,
    usbError: null,
    usbChecking: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_NAME:
        return Object.assign({}, state, {
            peripheralName: action.peripheralName
        });
    case CLEAR_NAME:
        return Object.assign({}, state, {
            peripheralName: null
        });
    case SET_REALTIME_PROTOCAL_CONNECTION:
        return Object.assign({}, state, {
            realtimeConnection: action.isConnected
        });
    case SET_LIST_ALL:
        return Object.assign({}, state, {
            isListAll: action.isListAll
        });
    case SET_USB_STATUS:
        return Object.assign({}, state, {
            usbPortCount: action.portCount,
            usbError: action.error || null,
            usbChecking: false
        });
    case SET_USB_CHECKING:
        return Object.assign({}, state, {
            usbChecking: true,
            usbPortCount: null,
            usbError: null
        });
    case CLEAR_USB_STATUS:
        return Object.assign({}, state, {
            usbPortCount: null,
            usbError: null,
            usbChecking: false
        });
    default:
        return state;
}
};

const setConnectionModalPeripheralName = function (peripheralName) {
    return {
        type: SET_NAME,
        peripheralName: peripheralName
    };
};

const clearConnectionModalPeripheralName = function () {
    return {
        type: CLEAR_NAME
    };
};

const setRealtimeConnection = function (isConnected) {
    return {
        type: SET_REALTIME_PROTOCAL_CONNECTION,
        isConnected: isConnected
    };
};

const setListAll = function (isListAll) {
    return {
        type: SET_LIST_ALL,
        isListAll: isListAll
    };
};

const setUsbStatus = function (portCount, error) {
    return {
        type: SET_USB_STATUS,
        portCount: portCount,
        error: error
    };
};

const clearUsbStatus = function () {
    return {
        type: CLEAR_USB_STATUS
    };
};

const setUsbChecking = function () {
    return {
        type: SET_USB_CHECKING
    };
};

export {
    reducer as default,
    initialState as connectionModalInitialState,
    setConnectionModalPeripheralName,
    clearConnectionModalPeripheralName,
    setRealtimeConnection,
    setListAll,
    setUsbStatus,
    clearUsbStatus,
    setUsbChecking
};
